import React, { useEffect, useRef } from "react"
import X from "../../public/icons/x.svg";
import { useModalFocus } from "../../lib/useModalFocus";

interface SharingMenuNNProps {
  onClose: () => void
  children: React.ReactNode
  title?: string
  className?: string
  triggerRef?: React.RefObject<HTMLElement>
}

const Drawer = ({ onClose, children, title, className, triggerRef }: SharingMenuNNProps) => {
  const classNames = ['drawer__content']
  if (className) classNames.push(className)
  
  const drawerRef = useRef<HTMLDivElement>(null)

  useModalFocus({
    isOpen: true,
    onClose,
    modalRef: drawerRef as React.RefObject<HTMLElement>,
    triggerRef
  });

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <div className="drawer" onClick={onClose}>
      <div 
        ref={drawerRef}
        className={classNames.join(' ')} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="drawer__content-header">
          {title && <p className="drawer__content-header-title">{title}</p>}
          <button 
            className="drawer__close" 
            onClick={onClose} 
            aria-label="Schließen"
          >
            <X alt="Schließen" />
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}

export default Drawer